import { useQuery } from 'react-query';
import { createApiQueryOptions } from './createApiQueryOptions';
import { toHookName } from '../../apis-infra';
import { useApisClientContext } from '../Providers';
export const createApiHook = _ref => {
  let {
    methodConfig
  } = _ref;
  const queryOptionsBuilder = createApiQueryOptions({
    methodConfig
  });
  return (request, enabled, options) => {
    const {
      httpClient
    } = useApisClientContext();
    const queryOptions = queryOptionsBuilder({
      httpClient,
      request,
      options
    });
    return useQuery({
      enabled,
      ...queryOptions
    });
  };
};
export const createApiHooks = _ref2 => {
  let {
    apiConfig
  } = _ref2;
  return Object.keys(apiConfig).reduce((acc, methodName) => {
    const methodConfig = apiConfig[methodName];
    return {
      ...acc,
      [toHookName(methodName)]: createApiHook({
        methodConfig
      })
    };
  }, {});
};
//# sourceMappingURL=createApiHook.js.map